import React, {Component} from 'react';
import logo from './FPSLogoColor.png';
import {Navbar, Nav, Button} from 'react-bootstrap';

export default class HeaderBar extends Component {
  render() {
    return (
      <Navbar bg="dark" expand="lg">
        <Navbar.Brand href="/">
          <img className="headerLogo" src={logo} alt=""/>
        </Navbar.Brand>
        <Navbar.Brand href="/">
          <h1 className="nameFont">Fruit Postal Service</h1>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Button href="/characters">Characters</Button>
            <Button href="/team">Meet the Team</Button>
            <Button className="steamButton" variant="success" href="https://store.steampowered.com/app/1089710/Fruit_Postal_Service/">Get it on Steam!</Button>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }
}
